import { Stack } from "@mui/material"
import awLogoIcon from "../../assets/images/aw-logo-icon.svg"
import Title from "./Title"
import { colors } from "../../services/config/colors"
import { useTranslation } from "react-i18next"
import { CSSProperties } from "react"

interface PlatformLogoProps {
  containerStyle?: CSSProperties
  textStyle?: CSSProperties
}

const PlatformLogo = ({ containerStyle, textStyle }: PlatformLogoProps) => {
  const { t } = useTranslation()

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      style={{ width: "100%", ...containerStyle }}
    >
      <img src={awLogoIcon} alt="AWorld" style={{ height: 38 }} />
      <Title
        fontSize={16}
        lineHeight="20px"
        fontWeight={900}
        color={colors.primaryLogo}
        style={{ textTransform: "uppercase", ...textStyle }}
      >
        {t("impact_management_platform")}
      </Title>
    </Stack>
  )
}

export default PlatformLogo
